// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type GetCountryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type GetCountryQuery = { __typename?: 'Query' } & {
  country: Types.Maybe<{ __typename?: 'Country' } & Pick<Types.Country, 'id' | 'name'>>;
};

export const GetCountryDocument = /*#__PURE__*/ gql`
    query getCountry($id: ID!) {
  country(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetCountryQuery__
 *
 * To run a query within a React component, call `useGetCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCountryQuery(
  baseOptions: Apollo.QueryHookOptions<GetCountryQuery, GetCountryQueryVariables> &
    ({ variables: GetCountryQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountryQuery, GetCountryQueryVariables>(GetCountryDocument, options);
}
export function useGetCountryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCountryQuery, GetCountryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCountryQuery, GetCountryQueryVariables>(GetCountryDocument, options);
}
// @ts-expect-error
export function useGetCountrySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCountryQuery, GetCountryQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCountryQuery, GetCountryQueryVariables>;
export function useGetCountrySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryQuery, GetCountryQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCountryQuery | undefined, GetCountryQueryVariables>;
export function useGetCountrySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryQuery, GetCountryQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCountryQuery, GetCountryQueryVariables>(GetCountryDocument, options);
}
export type GetCountryQueryHookResult = ReturnType<typeof useGetCountryQuery>;
export type GetCountryLazyQueryHookResult = ReturnType<typeof useGetCountryLazyQuery>;
export type GetCountrySuspenseQueryHookResult = ReturnType<typeof useGetCountrySuspenseQuery>;
